export default __webpack_public_path__ + "static/header-emote-love-89f6ce9e7274ebe87e974031d6c96fc1.png";